<div
    id="dashboard"
    class="container-fluid">
    <table class="table table-hover table-striped">
        <thead>
            <tr class="default">
                <th
                    abbr="Method"
                    nowrap
                    class="custom-header"
                    title="The plan creation method. Cloud icon indicates the plan is prepared in the portal.">
                    Method
                    <div class="custom-header-glyphicon-holder">
                        <button
                            type="button"
                            class="btn btn-default nlr-icon-btn"
                            title="Sort by method"
                            id="sortByMethodBtn"
                            (click)="sortColumn('pdfCreationMethod', true)">
                            <i
                                class="nlrp-icon nlrp-18 create"
                                [ngClass]="{
                                'nlrp-icon-sort': !isSortedBy('pdfCreationMethod'),
                                'nlrp-icon-expand-more': isSortedBy('pdfCreationMethod') && plansCasesSort.reverse,
                                'nlrp-icon-expand-less': isSortedBy('pdfCreationMethod') && !plansCasesSort.reverse}"></i>
                        </button>
                    </div>
                </th>
                <th
                    abbr="Customer reference"
                    nowrap
                    class="custom-header"
                    title="The customer reference of the plan">
                    Customer ref
                    <div class="custom-header-glyphicon-holder">
                        <button
                            type="button"
                            id="filterByCustomerRefBtn"
                            class="btn btn-default nlr-icon-btn"
                            title="Filter by customer reference"
                            (click)="filters.filterByCustomerReference = !filters.filterByCustomerReference">
                            <i class="nlrp-icon nlrp-icon-filter-off nlrp-18"></i>
                        </button>
                        @if (filters.filterByCustomerReference) {
                            <div class="input-group input-group-glyphicon">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit nlrp-18"></i>
                                </span>
                                <input
                                    type="text"
                                    class="white text-left"
                                    id="filterByCustomerReference"
                                    autocomplete="off"
                                    placeholder="Enter customer reference"
                                    nlrFocus
                                    (blur)="filters.filterByCustomerReference = !filters.filterByCustomerReference"
                                    [(ngModel)]="filters.filterByCustomerReferenceValue" />
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-filter-off nlrp-18"
                                        tabindex="0"
                                        (click)="filters.filterByCustomerReference = false"></i>
                                </span>
                            </div>
                        }
                    </div>
                </th>
                <th
                    abbr="Lodge type"
                    nowrap
                    class="custom-header"
                    title="The lodgement type of the plan">
                    Lodge type
                    <div class="custom-header-glyphicon-holder">
                        <button
                            type="button"
                            class="btn btn-default nlr-icon-btn"
                            title="Filter by lodgement type"
                            id="filterByPlanLodgeBtn"
                            (click)="filters.filterByPlanLodgementType = !filters.filterByPlanLodgementType">
                            <i class="nlrp-icon nlrp-icon-filter-off nlrp-18"></i>
                        </button>
                        @if (filters.filterByPlanLodgementType) {
                            <div class="input-group input-group-glyphicon">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit nlrp-18"></i>
                                </span>
                                <input
                                    type="text"
                                    class="white text-left"
                                    id="LodgementTypeId"
                                    autocomplete="off"
                                    placeholder="Enter lodgement type"
                                    nlrFocus
                                    (blur)="filters.filterByPlanLodgementType = !filters.filterByPlanLodgementType"
                                    [(ngModel)]="filters.filterByPlanLodgementTypeValue" />
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-filter-off nlrp-18"
                                        tabindex="0"
                                        (click)="filters.filterByPlanLodgementType = false"></i>
                                </span>
                            </div>
                        }
                    </div>
                </th>
                <th
                    abbr="Version"
                    nowrap
                    class="custom-header"
                    title="The plan version">
                    Version
                    <div class="custom-header-glyphicon-holder">
                        <button
                            type="button"
                            class="btn btn-default nlr-icon-btn"
                            title="Sort by version number"
                            id="sortByVersionBtn"
                            (click)="sortColumn('version')">
                            <i
                                class="nlrp-icon nlrp-18 create"
                                [ngClass]="{
                                    'nlrp-icon-sort': !isSortedBy('version'),
                                    'nlrp-icon-expand-more': isSortedBy('version') && plansCasesSort.reverse,
                                    'nlrp-icon-expand-less': isSortedBy('version') && !plansCasesSort.reverse}"></i>
                        </button>
                    </div>
                </th>
                <th
                    abbr="Description"
                    nowrap
                    class="custom-header"
                    title="The description of the plan">
                    Description
                    <div class="custom-header-glyphicon-holder">
                        <button
                            type="button"
                            class="btn btn-default nlr-icon-btn"
                            title="Filter by description"
                            id="filterByDescriptionBtn"
                            (click)="filters.filterByDescription = !filters.filterByDescription">
                            <i class="nlrp-icon nlrp-icon-filter-off nlrp-18"></i>
                        </button>
                        @if (filters.filterByDescription) {
                            <div class="input-group input-group-glyphicon">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit nlrp-18"></i>
                                </span>
                                <input
                                    type="text"
                                    class="white text-left"
                                    id="filterByDescription"
                                    autocomplete="off"
                                    placeholder="Enter description"
                                    nlrFocus
                                    (blur)="filters.filterByDescription = !filters.filterByDescription"
                                    [(ngModel)]="filters.filterByDescriptionValue" />
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-filter-off nlrp-18"
                                        tabindex="0"
                                        (click)="filters.filterByDescription = false"></i>
                                </span>
                            </div>
                        }
                    </div>
                </th>
                <th
                    abbr="Tenure type"
                    nowrap
                    class="custom-header"
                    title="The tenure type of the plan">
                    Tenure type
                    <div class="custom-header-glyphicon-holder">
                        <button
                            type="button"
                            id="filterByTenureTypeBtn"
                            class="btn btn-default nlr-icon-btn"
                            title="Filter by tenure type"
                            (click)="filters.filterByTenureType = !filters.filterByTenureType">
                            <i class="nlrp-icon nlrp-icon-filter-off nlrp-18"></i>
                        </button>
                        @if (filters.filterByTenureType) {
                            <div class="input-group input-group-glyphicon">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit nlrp-18"></i>
                                </span>
                                <input
                                    type="text"
                                    class="white text-left"
                                    id="filterByTenureType"
                                    autocomplete="off"
                                    placeholder="Enter tenure type"
                                    nlrFocus
                                    (blur)="filters.filterByTenureType = !filters.filterByTenureType"
                                    [(ngModel)]="filters.filterByTenureTypeValue" />
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-filter-off nlrp-18"
                                        tabindex="0"
                                        (click)="filters.filterByTenureType = false"></i>
                                </span>
                            </div>
                        }
                    </div>
                </th>
                <th
                    abbr="Plan type"
                    nowrap
                    class="custom-header"
                    title="The plan type of the plan">
                    Plan type
                    <div class="custom-header-glyphicon-holder">
                        <button
                            type="button"
                            class="btn btn-default nlr-icon-btn"
                            title="Filter by plan type"
                            id="filterByPlanTypeBtn"
                            (click)="filters.filterByPlanType = !filters.filterByPlanType">
                            <i class="nlrp-icon nlrp-icon-filter-off nlrp-18"></i>
                        </button>
                        @if (filters.filterByPlanType) {
                            <div class="input-group input-group-glyphicon">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit nlrp-18"></i>
                                </span>
                                <input
                                    type="text"
                                    class="white text-left"
                                    id="filterByPlanType"
                                    autocomplete="off"
                                    placeholder="Enter plan type"
                                    nlrFocus
                                    (blur)="filters.filterByPlanType = !filters.filterByPlanType"
                                    [(ngModel)]="filters.filterByPlanTypeValue" />
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-filter-off nlrp-18"
                                        tabindex="0"
                                        (click)="filters.filterByPlanType = false"></i>
                                </span>
                            </div>
                        }
                    </div>
                </th>
                <th
                    abbr="Plan number"
                    nowrap
                    class="custom-header"
                    title="The plan number of the plan">
                    Plan number
                    <div class="custom-header-glyphicon-holder">
                        <button
                            type="button"
                            id="filterByPlanNumberBtn"
                            class="btn btn-default nlr-icon-btn"
                            title="Filter by plan number"
                            (click)="filters.filterByPlanNumber = !filters.filterByPlanNumber">
                            <i class="nlrp-icon nlrp-icon-filter-off nlrp-18"></i>
                        </button>
                        @if (filters.filterByPlanNumber) {
                            <div class="input-group input-group-glyphicon">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit nlrp-18"></i>
                                </span>
                                <input
                                    type="text"
                                    class="white text-left"
                                    id="filterByPlanNumber"
                                    autocomplete="off"
                                    placeholder="Enter plan number"
                                    nlrFocus
                                    (blur)="filters.filterByPlanNumber = !filters.filterByPlanNumber"
                                    [(ngModel)]="filters.filterByPlanNumberValue" />
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-filter-off nlrp-18"
                                        tabindex="0"
                                        (click)="filters.filterByPlanNumber = false"></i>
                                </span>
                            </div>
                        }
                    </div>
                </th>
                <th
                    abbr="Purpose"
                    nowrap
                    class="custom-header"
                    title="The purpose of the plan">
                    Purpose
                    <div class="custom-header-glyphicon-holder">
                        <button
                            type="button"
                            class="btn btn-default nlr-icon-btn"
                            title="Filter by purpose"
                            id="filterByPurposeBtn"
                            (click)="filters.filterByPurpose = !filters.filterByPurpose">
                            <i class="nlrp-icon nlrp-icon-filter-off nlrp-18"></i>
                        </button>
                        @if (filters.filterByPurpose) {
                            <div class="input-group input-group-glyphicon">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit nlrp-18"></i>
                                </span>
                                <input
                                    type="text"
                                    class="white text-left"
                                    id="filterByPurpose"
                                    autocomplete="off"
                                    placeholder="Enter purpose"
                                    nlrFocus
                                    (blur)="filters.filterByPurpose = !filters.filterByPurpose"
                                    [(ngModel)]="filters.filterByPurposeValue" />
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-filter-off nlrp-18"
                                        tabindex="0"
                                        (click)="filters.filterByPurpose = false"></i>
                                </span>
                            </div>
                        }
                    </div>
                </th>
                <th
                    abbr="Survey firm"
                    nowrap
                    class="custom-header"
                    title="The survey firm associated with the plan">
                    Survey firm
                    <div class="custom-header-glyphicon-holder">
                        <button
                            type="button"
                            class="btn btn-default nlr-icon-btn"
                            title="Filter by Survey firm"
                            id="filterBySurveyFirmBtn"
                            (click)="filters.filterBySurveyorFirmName = !filters.filterBySurveyorFirmName">
                            <i class="nlrp-icon nlrp-icon-filter-off nlrp-18"></i>
                        </button>
                        @if (filters.filterBySurveyorFirmName) {
                            <div class="input-group input-group-glyphicon">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit nlrp-18"></i>
                                </span>
                                <input
                                    type="text"
                                    class="white text-left"
                                    id="filterByTenure"
                                    autocomplete="off"
                                    placeholder="Enter survey firm"
                                    nlrFocus
                                    (blur)="filters.filterBySurveyorFirmName = !filters.filterBySurveyorFirmName"
                                    [(ngModel)]="filters.filterBySurveyorFirmNameValue" />
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-filter-off nlrp-18"
                                        tabindex="0"
                                        (click)="filters.filterBySurveyorFirmName = false"></i>
                                </span>
                            </div>
                        }
                    </div>
                </th>
                @if (!isLodgeTabEnabled()) {
                    <th
                        abbr="Created by"
                        nowrap
                        class="custom-header"
                        title="Who the plan was created by">
                        Created by
                        <div class="custom-header-glyphicon-holder">
                            <button
                                type="button"
                                class="btn btn-default nlr-icon-btn"
                                title="Filter by creator"
                                id="filterByCreatorBtn"
                                (click)="filters.filterByPlanCreator = !filters.filterByPlanCreator">
                                <i class="nlrp-icon nlrp-icon-filter-off nlrp-18"></i>
                            </button>
                            @if (filters.filterByPlanCreator) {
                                <div class="input-group input-group-glyphicon">
                                    <span class="input-group-addon">
                                        <i class="nlrp-icon nlrp-icon-edit nlrp-18"></i>
                                    </span>
                                    <input
                                        type="text"
                                        class="white text-left"
                                        id="lodgementCaseId"
                                        autocomplete="off"
                                        placeholder="Enter plan creator"
                                        nlrFocus
                                        (blur)="filters.filterByPlanCreator = !filters.filterByPlanCreator"
                                        [(ngModel)]="filters.filterByPlanCreatorValue" />
                                    <span class="input-group-addon">
                                        <i
                                            class="nlrp-icon nlrp-icon-filter-off nlrp-18"
                                            tabindex="0"
                                            (click)="filters.filterByPlanCreator = false"></i>
                                    </span>
                                </div>
                            }
                        </div>
                    </th>
                }
                @if (isLodgeTabEnabled()) {
                    <th
                        abbr="Certifying surveyor"
                        nowrap
                        class="custom-header"
                        title="Who the plan was certified by">
                        Certifying surveyor
                        <div class="custom-header-glyphicon-holder">
                            <button
                                type="button"
                                class="btn btn-default nlr-icon-btn"
                                title="Filter by certifier"
                                id="filterByCertifierBtn"
                                (click)="filters.filterByCertifyingSurveyor = !filters.filterByCertifyingSurveyor">
                                <i class="nlrp-icon nlrp-icon-filter-off nlrp-18"></i>
                            </button>
                            @if (filters.filterByCertifyingSurveyor) {
                                <div class="input-group input-group-glyphicon">
                                    <span class="input-group-addon">
                                        <i class="nlrp-icon nlrp-icon-edit nlrp-18"></i>
                                    </span>
                                    <input
                                        type="text"
                                        class="white text-left"
                                        id="CertifyingSurveyorId"
                                        autocomplete="off"
                                        placeholder="Enter plan certifier"
                                        nlrFocus
                                        (blur)="filters.filterByCertifyingSurveyor = !filters.filterByCertifyingSurveyor"
                                        [(ngModel)]="filters.filterByCertifyingSurveyorValue" />
                                    <span class="input-group-addon">
                                        <i
                                            class="nlrp-icon nlrp-icon-filter-off nlrp-18"
                                            tabindex="0"
                                            (click)="filters.filterByCertifyingSurveyor = false"></i>
                                    </span>
                                </div>
                            }
                        </div>
                    </th>
                }
                @if (!isLodgeTabEnabled()) {
                    <th
                        abbr="Status date"
                        nowrap
                        class="custom-header"
                        title="The plan status date of the plan">
                        Status date
                        <div class="custom-header-glyphicon-holder">
                            <button
                                type="button"
                                class="btn btn-default nlr-icon-btn"
                                title="Sort by status date"
                                id="filterByStatusDateBtn"
                                (click)="sortColumn('statusDate')">
                                <i
                                    class="nlrp-icon nlrp-18 create nlrp-icon-expand-more"
                                    [ngClass]="{
                                    'nlrp-icon-sort': !isSortedBy('statusDate'),
                                    'nlrp-icon-expand-more': isSortedBy('statusDate') && plansCasesSort.reverse,
                                    'nlrp-icon-expand-less': isSortedBy('statusDate') && !plansCasesSort.reverse}"></i>
                            </button>
                        </div>
                    </th>
                }
                @if (isLodgeTabEnabled()) {
                    <th
                        abbr="Lodged date"
                        nowrap
                        class="custom-header"
                        title="The lodged date of the plan">
                        Lodged date
                        <div class="custom-header-glyphicon-holder">
                            <button
                                type="button"
                                class="btn btn-default nlr-icon-btn"
                                title="Sort by lodged date"
                                id="sortByLodgedDateBtn"
                                (click)="sortColumn('statusDate')">
                                <i
                                    class="nlrp-icon nlrp-18 create"
                                    [ngClass]="{
                                       'nlrp-icon-expand-more': isSortedBy('statusDate') && plansCasesSort.reverse,
                                       'nlrp-icon-expand-less': isSortedBy('statusDate') && !plansCasesSort.reverse,
                                       'nlrp-icon-sort': !isSortedBy('statusDate')}"></i>
                            </button>
                        </div>
                    </th>
                }
                <th
                    abbr="Action status"
                    nowrap
                    class="custom-header"
                    title="Action status">
                    <span>Actions</span>
                    <button
                        type="button"
                        class="btn btn-default nlr-icon-btn pull-right"
                        title="Reset all filters"
                        id="resetFiltersBtn"
                        (click)="resetFilters()">
                        <i class="nlrp-icon nlrp-icon-clear-filter nlrp-18"></i>
                    </button>
                </th>
            </tr>
        </thead>
        <tbody>
            @for (plan of paginatedPlansData; track plan; let i = $index) {
                <tr>
                    <td>
                        @if (plan.pdfCreationMethod === PDF_CREATION_METHOD_DESCRIPTION.SURVEYOR_PORTAL) {
                            <i
                                class="nlrp-icon nlrp-icon-portal-plan nlrp-18"
                                title="NLR portal generated plan"></i>
                        }
                        @if (plan.pdfCreationMethod === PDF_CREATION_METHOD_DESCRIPTION.DIGITAL_PLAN) {
                            <i
                                class="digital-plan-icon"
                                title="Digital Plan"></i>
                        }
                    </td>
                    <td>
                        <div
                            class="dashboard-customer-reference"
                            [title]="plan.customerReference"
                            >{{plan.customerReference}}</div
                        >
                    </td>
                    <td>{{plan.planLodgementType}}</td>
                    <td>{{plan.version}}</td>
                    <td>
                        <div
                            class="dashboard-description"
                            [title]="plan.description"
                            >{{plan.description}}</div
                        >
                    </td>
                    <td>{{plan.tenureType}}</td>
                    <td>{{plan.planType}}</td>
                    <td>{{plan.planNumber}}</td>
                    <td>
                        <div
                            class="dashboard-plan-purpose"
                            [title]="plan.planPurpose"
                            >{{plan.planPurpose}}</div
                        >
                    </td>
                    <td>
                        <div
                            class="dashboard-surveyor-firm-name"
                            [title]="plan.surveyorFirmName"
                            >{{plan.surveyorFirmName}}</div
                        >
                    </td>
                    <td>
                        @if (!isLodgeTabEnabled()) {
                            <div
                                class="dashboard-created-by"
                                [title]="plan.creatorName"
                                >{{plan.creatorName}}</div
                            >
                        }
                        @if (isLodgeTabEnabled()) {
                            <div
                                class="dashboard-certifying-surveyor"
                                [title]="plan.certifyingSurveyor"
                                >{{plan.certifyingSurveyor}}</div
                            >
                        }
                    </td>
                    <td [title]="plan.statusDate | date:'dd/MM/yyyy HH:mm:ss'">{{plan.statusDate | date:'dd/MM/yyyy'}} </td>
                    <td
                        nowrap
                        class="vertical-middle text-right">
                        <div>
                            @if (isPlanAssignedToCurrentUser(plan) && showEditPlanButton && hasActionPermissions(editPlanPermissions)) {
                                <i
                                    class="nlrp-icon nlrp-icon-edit nlrp-18"
                                    title="Edit plan"
                                    id="editPlanBtn"
                                    (click)="editPlan(plan)">
                                </i>
                            }
                            @if (showAdditionalsButton && hasActionPermissions(editAdditionalsPermissions)) {
                                <i
                                    class="nlrp-icon nlrp-icon-lodge-additionals nlrp-18"
                                    title="Lodge additionals"
                                    id="lodgeAdditionalsBtn"
                                    (click)="lodgeAdditionals(plan)">
                                </i>
                            }
                            @if (showAmendPlanButton && hasActionPermissions(amendPlanPermissions)) {
                                <i
                                    class="nlrp-icon nlrp-icon-amend-plan nlrp-18"
                                    title="Amend plan"
                                    id="amendPlanBtn"
                                    (click)="amendPlan(plan)">
                                </i>
                            }
                            @if (showReplacePlanButton && hasActionPermissions(replacePlanPermissions)) {
                                <i
                                    class="nlrp-icon nlrp-icon-replace-plan nlrp-18"
                                    title="Replace plan"
                                    id="replacePlanBtn"
                                    (click)="replacePlan(plan)">
                                </i>
                            }
                            @if (showViewPlanButton && hasActionPermissions(viewPlanPermissions)) {
                                <i
                                    class="nlrp-icon nlrp-icon-view nlrp-18"
                                    title="View plan"
                                    (click)="viewPlan(plan.planLodgementId)"></i>
                            }
                            @if (showViewPlanPdfButton && hasActionPermissions(viewPlanPermissions)) {
                                <i
                                    class="nlrp-icon nlrp-icon-view-pdf nlrp-18"
                                    title="View plan pdf"
                                    id="viewPlanPdfBtn"
                                    (click)="viewPdfOnlyPlan(plan)"></i>
                            }
                            @if (showAssignPlanButton && hasActionPermissions(assignPlanPermissions)) {
                                <i
                                    class="nlrp-icon nlrp-icon-assign-plan nlrp-18"
                                    title="Assign plan"
                                    (click)="openAssignPlan(plan)"></i>
                            }
                            @if (showRemovePlanButton && hasActionPermissions(editPlanPermissions)) {
                                <i
                                    class="nlrp-icon nlrp-icon-trash nlrp-18"
                                    [ngClass]="{'icon-disabled': removePlanIsDisabled(plan)}"
                                    [title]="removePlanIsDisabled(plan) ? 'This plan can only be deleted by the creator or the assigned user' : 'Remove plan'"
                                    (click)="removePlan(plan)"></i>
                            }
                        </div>
                    </td>
                </tr>
            }
        </tbody>
    </table>
    @if (isAssignPlanModalOpen) {
        <nlr-assign-plan
            (assignPlanEvent)="assignPlan($event)"
            (modalCloseEvent)="dismissModal()"></nlr-assign-plan>
    }
</div>
